import { render } from "./TitleBarEx.vue?vue&type=template&id=205c6eb6&scoped=true"
import script from "./TitleBarEx.vue?vue&type=script&lang=js"
export * from "./TitleBarEx.vue?vue&type=script&lang=js"

import "./TitleBarEx.vue?vue&type=style&index=0&id=205c6eb6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205c6eb6"]])

export default __exports__